import React from "react";

function ServiceCard({ title, description, image }) {
  return (
    <div className="contact-us">
      <div
        className="calling"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <h1>{title}</h1>
      <div className="land-number">
        <p>{description}</p>
      </div>
    </div>
  );
}

export default ServiceCard;
